import {
  IonButtons,
  IonHeader,
  IonIcon,
  IonTitle,
  IonToolbar,
  useIonToast,
} from "@ionic/react";
import { exit, home } from "ionicons/icons";
import { signOut } from "firebase/auth";
import { auth } from "../utils/db";
import { IonButton } from "@ionic/react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

export default function Menu({ title }) {
  const [presentToast] = useIonToast();
  const history = useHistory();

  const goHome = () => {
    history.push("/home");
  };

  const logout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      presentToast({
        header: "Erro no Logout",
        message: error.message,
        buttons: ["OK"],
      });
    }
  };

  return (
    <IonHeader className="clear-content">
      <IonToolbar>
        <IonButtons slot="start">
          <IonButton onClick={goHome}>
            <IonIcon icon={home} />
          </IonButton>
        </IonButtons>

        <IonTitle>{title}</IonTitle>

        <IonButtons slot="end">
          <IonButton onClick={logout}>
            <IonIcon icon={exit} />
          </IonButton>
        </IonButtons>
      </IonToolbar>
    </IonHeader>
  );
}
